export default __webpack_public_path__ + "static/skillBar-faded-592770b7c6fa1381d474b6768008f3f7.png";